<template>
  <div class="page page-inner">
    <breadcrumb title="Travel Request"></breadcrumb>
    <div class="card card-fluid">
      <!-- .card-header -->
      <div class="card-header nav-scroller">
        <!-- .nav-tabs -->
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item">
            <a href="#" class="nav-link active" @click.prevent="setActive('travel-request')" data-toggle="tab">Travel
              Request</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click.prevent="setActive('travel-approval')" data-toggle="tab">Travel
              Approval</a>
          </li>
        </ul>
        <!-- /.nav-tabs -->
      </div>
      <!-- /.card-header -->


      <!-- .card-body -->
      <div class="card-body">
        <div class="tab-content py-3" id="myTabContent">
          <div class="tab-pane fade" :class="{ 'active show': isActive('travel-request') }" id="home">
            <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="dt-buttons btn-group">
                    <button class="btn btn-success btn-modal" @click="toInput" tabindex="0"
                            aria-controls="data-table-leave-request-request" type="button" data-title="Request" v-show="action_button.add">
                      <span>Request</span>
                    </button>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="data-table-leave-request-request_filter" class="dataTables_filter"><label>Search:<input
                      type="search" class="form-control" placeholder=""
                      aria-controls="data-table-leave-request-request"></label></div>
                </div>
              </div>

              <b-table hover :items="items" :fields="fields" :sticky-header="stickyHeader"
                       :no-border-collapse="noCollapse" :sort-direction="sortDirection" :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc" responsive
                       table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" class="table-height"
                       :class="{'hide-scroll': isScrollHide()}">

                <template v-slot:cell(action)="row">
                  <a class="btn btn-xs"
                     @click="detailRow(row.item, row.index, $event.target)" title="Detail" v-show="action_button.detail">
                    <em class="fa fa-search"></em>
                  </a>
                  <a class="btn btn-xs" v-if="(row.item.travel_stat_id == 0 || row.item.travel_stat_id == 8 || row.item.travel_stat_id == null) && action_button.edit"
                     @click="editRow(row.item, row.index, $event.target)" title="Edit">
                    <em class="fa fa-pencil-alt"></em>
                  </a>
                  <a class="btn btn-xs" v-if="(row.item.travel_stat_id == 0 || row.item.travel_stat_id == 8) && action_button.delete"
                     @click="deleteRow(row.item, row.index, $event.target)" title="Delete">
                    <em class="fa fa-trash"></em>
                  </a>
                </template>
              </b-table>
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_info" id="data-table-leave-request-request_info" role="status"
                       aria-live="polite">Showing {{ currentPage }} to {{ perPage }} of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                  <div class="dataTables_paginate paging_simple_numbers">
                    <b-pagination v-model="currentPage" v-on:click="getData" :per-page="perPage" :total-rows="rows"
                                  :align="right"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('travel-approval') }" id="profile">
            <div id="data-table-leave-request-approval_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="data-table-leave-approval-request_filter" class="dataTables_filter"><label>Search:<input
                      type="search" class="form-control" placeholder=""
                      aria-controls="data-table-leave-request-request"></label></div>
                </div>
              </div>

              <b-table hover :items="items" :fields="fields" :sticky-header="stickyHeader"
                       :no-border-collapse="noCollapse" :sort-direction="sortDirection" :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc" responsive
                       class="table-height"
                       table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover
                       :class="{'hide-scroll': isScrollHide()}">

                <template v-slot:cell(action)="row">
                  <a class="btn btn-xs"
                     @click="detailRow(row.item, row.index, $event.target)" title="Detail">
                    <em class="fa fa-search"></em>
                  </a>
                </template>
              </b-table>
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_info" id="data-table-leave-approval-request_info" role="status"
                       aria-live="polite">Showing {{ currentPage }} to {{ perPage }} of {{ rows }} entries
                  </div>
                </div>
                <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                  <div class="dataTables_paginate paging_simple_numbers">
                    <b-pagination v-model="currentPage" v-on:click="getData" :per-page="perPage" :total-rows="rows"
                                  :align="right"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteItem" @hide="resetModal" ok-title="Delete" ok-variant="danger">
      <p class="my-2">
        Are you sure delete this item ?
      </p>
    </b-modal>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

import {mapGetters} from "vuex";
import {BButton, BModal, BPagination, BTable} from "bootstrap-vue"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import Acl from "../../../../libs/AclButton";

export default {
  name: "TravelRequest",
  components: {
    Breadcrumb,
    BTable,
    BPagination,
    BModal
  },
  data() {
    return {
      activeItem: "travel-request",
      noCollapse: false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items: [],
      fields: [
        {key: 'no', sortable: true, thStyle: {maxWidth: '60px', minWidth: '10px'}},
        {key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'}},
        {key: 'number', sortable: true, label: "Transaction Number"},
        {key: 'date', label: 'Request Date', sortable: true},
        {key: 'emp_name', label: 'Employee', sortable: true},
        {key: 'purpose_name', label: 'Purpose', sortable: true},
        {key: 'activity_start', label: 'Activity Start', sortable: true},
        {key: 'activity_end', label: 'Activity End', sortable: true},
        {key: 'travel_stat_name', label: 'Travel Status', sortable: true},
        {key: 'activities', label: 'Notes', sortable: true},
      ],
      rows: 0,
      perPage: 20,
      currentPage: 1,
      right: "right",
      action_button:{
        add:false,
        edit:false,
        delete:false,
        detail:false
      }
    }
  },
  computed: {
    ...mapGetters(['scrollbarHide']),
  },
  watch:{
    currentPage(){
      this.getData()
    }
  },
  methods: {
    isScrollHide() {
      return this.scrollbarHide
    },
    setActive(itemTabs) {
      this.activeItem = itemTabs
      this.getData()
    },
    isActive(itemTabs) {
      return this.activeItem === itemTabs
    },
    getData() {
      this.items = []
      let payload = {
        page:this.currentPage,
        limit:this.perPage,
      }
      if(this.activeItem === "travel-approval") payload.approval = true
      AxiosCall.Get(payload, urlApi.travel_request.index).then(res=>{
        if(res.success){
          let no = (this.currentPage - 1) * this.perPage +1
          for(let data of res.atributes){
            data.no = no++
            this.items.push(data)
          }
          this.rows = res.total
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    toInput() {
      this.$router.push({path: "travel-request-input"})
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    editRow(item){
      this.$router.push({name:"TravelRequestInput", query:{id:item.id}})
    },
    detailRow(item){
      this.$router.push({name:"TravelRequestDetail", query:{id:item.id}})
    },
    deleteRow(item){
      this.data = item
      this.$refs["modal-delete"].show()
    },
    deleteItem(){
      AxiosCall.Delete(urlApi.travel_request.delete+"/"+this.data.id).then(res=>{
        if (res.success){
          this.successMessage(res.message)
          this.getData()
          this.$refs["modal-delete"].hide()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    resetModal(){
      this.data = null
    },
    checkAction(){
      for(let act in this.action_button){
        this.action_button[act] = Acl(this.$options.name, act)
      }
    }
  },
  created() {
    this.checkAction()
    this.getData()
  }
}
</script>